// 单文件引入方式

import Tabs from './ZuiTabs.vue'

export default {
  install(Vue) {
    Vue.component('ZuiTabs', Tabs)
  }
}

export { Tabs }
